import React, { useContext } from "react";
import { SessionContext } from "../context/sessionContext";

//EX 18-09-2026: barra superior del formulario de expediente. Lleva el boton Cancelar y, para admin,
//la leyenda con el estado actual del formulario (NUEVO / EDICION) que se agrego para poder seguir la
//unificacion de alta y edicion.
//Es permanente, no codigo temporal: la leyenda queda como indicador para admin, asi no hay que
//acordarse de quitarla.
//Se usa en las dos pantallas (alta y edicion) para que se vean iguales y para no repetir el markup.
//
//El rol se lee del contexto (mismo criterio que el boton Borrar de la edicion y que isAdmin de
//navigation.jsx: roleA.roleA === 'admin'), asi ningun llamador tiene que pasar la bandera.
//
//Estilos con clases de Tailwind (no inline). Las dos clases de color del estado van escritas completas
//para que Tailwind las genere: no se pueden armar concatenando pedazos, porque el escaneo es de texto.
//Los valores sueltos (13px, 1px) van como valor arbitrario [..] para conservar el aspecto original.
const BarraEstadoFormulario = ({ estado, onCancelar }) => {
	const { roleA } = useContext(SessionContext);
	const esAdmin = roleA?.roleA === "admin";

	const colorEstado = estado === "EDICIÓN" ? "bg-[#c8102e]" : "bg-[#0b7fab]";

	return (
		//Cancelar a la izquierda; la leyenda (solo admin) al extremo derecho.
		<div className="flex items-center justify-between gap-2.5 w-full">

			<button type="button" className="btn btn-success button_verde" onClick={onCancelar}>
				Cancelar
			</button>

			{esAdmin &&
				<span className={`${colorEstado} text-white px-3.5 py-1 rounded-xl text-[13px] font-bold tracking-[1px] whitespace-nowrap shrink-0`}>
					ESTADO: {estado}
				</span>
			}
		</div>
	)
}

export default BarraEstadoFormulario;
